/**
 * Utility functions for ServiceView
 */

/**
 * Convert kebab-case to camelCase
 * @param str String in kebab-case
 * @returns String in camelCase
 */
export function kebabToCamel(str: string): string {
  return str.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
}

/**
 * Convert kebab-case to Title Case
 * @param str String in kebab-case
 * @returns String in Title Case
 */
export function kebabToTitle(str: string): string {
  return str
    .split("-")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

/**
 * Convert camelCase to Title Case
 * @param str String in camelCase
 * @returns String in Title Case
 */
export function camelToTitle(str: string): string {
  // Handle acronyms and insert spaces before capital letters
  const result = str.replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .replace(/([a-z\d])([A-Z])/g, "$1 $2")
    .replace(/([a-z])(\d)/g, "$1 $2");
  
  // Capitalize first letter and return
  return result.charAt(0).toUpperCase() + result.slice(1);
}